import { signUp } from "@/modules/auth/service";
import validateInputs from "./validate-inputs";

export default async function signUpAction({ request }) {
  const searchParams = new URL(request.url).searchParams;
  const formData = await request.formData();

  const formErrors = validateInputs(formData);

  if (Object.keys(formErrors).length) {
    return { formErrors };
  }

  const { error } = await signUp({
    email: formData.get("email"),
    metadata: {
      firstName: formData.get("firstName"),
      lastName: formData.get("lastName"),
    },
  });

  if (error) return { error };

  const priceId = searchParams.get("priceId") || formData.get("priceId");

  return {
    email: formData.get("email"),
    accountName: formData.get("accountName"),
    priceId,
  };
}
